const anghami_cdn = 'https://cdnweb.anghami.com';
export const getAssetPath = (path: string) => {
	return `${anghami_cdn}/new/${path.startsWith('/') ? path.slice(1) : path}`;
};
